export default __webpack_public_path__ + "static/processIcon-5312ae789e5a597d82a26acdcc227e9b.svg";